import { render, staticRenderFns } from "./portal-membresia.vue?vue&type=template&id=dfbea07e&scoped=true&"
import script from "./portal-membresia.vue?vue&type=script&lang=js&"
export * from "./portal-membresia.vue?vue&type=script&lang=js&"
import style0 from "./portal-membresia.vue?vue&type=style&index=0&id=dfbea07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbea07e",
  null
  
)

export default component.exports